<template>
  <!-- 全局提示框 -->
  <div v-show="visible" class="dialog-tips dialog-center">
    <div class="tip">{{message}}</div>
  </div>
</template>

<script>
/* eslint-disable no-tabs */
export default {
  name: 'ToastComponent',
  data () {
    return {
      visible: false,
      message: ''
    }
  }
}
</script>

<style>
.dialog-tips {
  position: fixed;
  z-index: 10000000000;
  min-width: 220px;
  padding: 20px 22px;
  white-space: nowrap;
  background-color: #000000;
  box-shadow: 0px 8px 15px 0 rgba(0, 0, 0, 0.1);
	opacity: .8;
  text-align: center;
}
.dialog-tips .dialog-tips-icon {
	width: 54px;
	height: 54px;
	@extend %bg-contain;
	display: inline-block;
	margin-bottom: 13px;
}
.dialog-center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}
.tip {
	color: #FFFFFF;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/tip.vue